import styled from 'styled-components'

export const OverviewContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &,
    * {
        transition: 0.3s all;
    }

    * {
        scrollbar-width: auto;
        scrollbar-color: var(--gray-300) var(--gray-100);
    }

    *::-webkit-scrollbar {
        width: 16px;
    }

    *::-webkit-scrollbar-track {
        background: var(--gray-100);
    }

    *::-webkit-scrollbar-thumb {
        background-color: var(--gray-300);
        border-radius: 10px;
        border: 3px solid var(--gray-100);
    }
`

export const AbsoluteLoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    background: var(--gray-300);
`

export const CustomOverviewAlert = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    width: 100%;
    gap: 4px;
    background: var(--gray-300);
`
